import React from 'react';
import './PickPackage.scss';
import { Divider, Icon } from 'antd';

interface IProps {
  title: string;
  text: string;
}

interface IState {
  isShowingText: boolean;
}

class PackageItem extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      isShowingText: false,
    }
  }

  onToggleTextClick = () => {
    this.setState({ isShowingText: !this.state.isShowingText });
  }

  render() {

    const { isShowingText } = this.state;
    const iconType = isShowingText ? 'caret-up' : 'caret-down';
    const {  children, text, title } = this.props;

    const oneliner = !text ? null :
    text.length < 165 ? text : text.substr(0, 165).concat('...');

    return (
      <>
        <div className='package-item'>
          { text && text.length >= 150 ?
            <div onClick={ this.onToggleTextClick }>
              <div className='name medium-bold'>
                <Icon type={ iconType } />{ title }
              </div>
              { !isShowingText &&
                <div className='package-text' dangerouslySetInnerHTML={ { __html: oneliner } } />
              }
            </div> :
            text && text.length > 0 ?
              <div>
                <div className='name medium-bold'>
                  { title }
                </div>
                { !isShowingText &&
                  <div className='package-text' dangerouslySetInnerHTML={ { __html: oneliner } } />
                }
              </div> :
            <div className='name medium-bold'>
              { title }
            </div>
          }
          { isShowingText && 
            <span className='package-text' dangerouslySetInnerHTML={ { __html: text } } />
          }
          { children }
        </div>
        <Divider />
      </>
    );
  }
}

export default PackageItem; 


// WEBPACK FOOTER //
// ./src/components/PickPackage/PackageItem.tsx